export const years = ['2015', '2016', '2017', '2018', '2019', '2022']

export const regular = [
  'Konventste',
  'Rooibos',
  'Sencha Lime',
  'Lapsang',
  'Golden Nepal',
]
